import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons';
import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Spinner,
  } from '@chakra-ui/react';
import { useState, FormEvent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { addCaptinRequest, addCaptinResponse } from '../../../shared/src/api';
import { ENDPOINT_CONFIGS } from '../endpoints';
import { ApiError, callEndpoint } from '../fetch';
import { isAdmin, isLoggedIn } from '../fetch/auth';
import { setCaptinsLocally } from '../fetch/captins';
import { ROUTES } from '../routes';


  export default function AddCaptinCard() {
    const navigate = useNavigate();
    const [error, setError] = useState('');
const [resOk,setResOk]=useState(false);
const [busy, setBusy] = useState(false);

    if (!isLoggedIn()) {
      navigate(ROUTES.SIGN_IN);
    }
    if (!isAdmin()) {
      navigate(ROUTES.HOME);
    }

    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
 
    
    const handleSubmit= useCallback(
     async (e: FormEvent | MouseEvent) =>{
        e.preventDefault();
     
        setBusy(true);
        setResOk(false);
    
        try{
        await callEndpoint<addCaptinRequest, addCaptinResponse>(( ENDPOINT_CONFIGS.addCaptin), {
            email:email,
            name:name
        });
     
        setCaptinsLocally();
        setResOk(true);
        setError('');
        setBusy(false);
       } catch (e) {
         setError((e as ApiError).message);
         setBusy(false);
       }
      }
  ,[email,name]);

    return (
        <form onSubmit={handleSubmit}>
           <fieldset disabled={busy}>
      <Flex
        minH={'100vh'}

        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'}>Add Captin</Heading>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>

              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)}/>
              </FormControl>
              
              <FormControl id="name" isRequired>
                <FormLabel>Name</FormLabel>
                <Input type="text" value={name} onChange={e => setName(e.target.value)}/>
              </FormControl>

              <Stack spacing={10}>
                
                <Button
                type='submit' 
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  Save
                </Button>

                {resOk &&
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">Captin added successfully</Text>               
              </Stack> 
              }
                {!!error &&
               <Stack justifyContent={'center'} direction={'row'} spacing={2}  >
                <CloseIcon boxSize={'20px'} color={'white'} />
               <Text color="red.700" >{error}</Text>             
               </Stack>
               }
               
              </Stack>
            </Stack>
          {busy &&  
          <Stack pt={4}>
            <Spinner  alignSelf={'center'} />
            </Stack>
          }
          </Box>
        </Stack>
      </Flex>
      </fieldset>
      </form>
    );
  }